/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { QuoteSubHeader_ProjectFragmentDoc, QuoteSubHeader_QuoteFragmentDoc } from '../../features/quotes/QuoteSubHeader.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectQuoteTroubleshootQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  docId: Types.Scalars['ID']['input'];
}>;


export type ProjectQuoteTroubleshootQuery = { project: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string } | null }, quote: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteResult', quote?: { __typename: 'Quote', id: string, title: string, viewerPermissions: Array<Types.PermissionName>, number: string, isPublished: boolean, isBinding: boolean, needsAgreement: boolean, agreement: Types.Agreement, owningSystemOrganisationId: string, canBeDeleted: boolean, templateOriginQuoteId?: string | null, rootItem: { __typename: 'Item', id: string, originVersionNumber?: number | null }, agreedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | null }, compileDocIsolatedExpression: { __typename: 'CompileDocIsolatedExpressionResult', results: Array<{ __typename: 'CompileDocIsolatedExpressionResultDiagnosticAskIf', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, key: string, askIfExpr: string, messageText: string } | { __typename: 'CompileDocIsolatedExpressionResultDiagnosticAttribute', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, attribute: string, expr: string, messageText: string } | { __typename: 'CompileDocIsolatedExpressionResultDiagnosticComputedProp', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, key: string, expr: string, messageText: string } | { __typename: 'CompileDocIsolatedExpressionResultDiagnosticProductSearchFilterExpression', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, expr: string, messageText: string, filterKind: Types.ProductSearchFilterExpressionFilterKind, filterKey: Types.ProductSearchFilterExpressionFilterKey, propertyKey?: string | null, operator: Types.EntitySearchFilterOperator, allowedOperators: Array<Types.EntitySearchFilterOperator> } | { __typename: 'CompileDocIsolatedExpressionResultDiagnosticPropertyMapping', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, toKey: string, fromExpr: string, messageText: string } | { __typename: 'CompileDocIsolatedExpressionResultDiagnosticRecommendedEligibleIf', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, expr: string, messageText: string, itemRecommendationId: string, itemRecommendationRank: number } | { __typename: 'CompileDocIsolatedExpressionResultDiagnosticRecommendedIncludeIf', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, expr: string, messageText: string, itemRecommendationId: string, itemRecommendationRank: number }> } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticAskIf_Fragment = { __typename: 'CompileDocIsolatedExpressionResultDiagnosticAskIf', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, key: string, askIfExpr: string, messageText: string };

export type ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticAttribute_Fragment = { __typename: 'CompileDocIsolatedExpressionResultDiagnosticAttribute', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, attribute: string, expr: string, messageText: string };

export type ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticComputedProp_Fragment = { __typename: 'CompileDocIsolatedExpressionResultDiagnosticComputedProp', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, key: string, expr: string, messageText: string };

export type ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticProductSearchFilterExpression_Fragment = { __typename: 'CompileDocIsolatedExpressionResultDiagnosticProductSearchFilterExpression', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, expr: string, messageText: string, filterKind: Types.ProductSearchFilterExpressionFilterKind, filterKey: Types.ProductSearchFilterExpressionFilterKey, propertyKey?: string | null, operator: Types.EntitySearchFilterOperator, allowedOperators: Array<Types.EntitySearchFilterOperator> };

export type ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticPropertyMapping_Fragment = { __typename: 'CompileDocIsolatedExpressionResultDiagnosticPropertyMapping', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, toKey: string, fromExpr: string, messageText: string };

export type ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticRecommendedEligibleIf_Fragment = { __typename: 'CompileDocIsolatedExpressionResultDiagnosticRecommendedEligibleIf', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, expr: string, messageText: string, itemRecommendationId: string, itemRecommendationRank: number };

export type ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticRecommendedIncludeIf_Fragment = { __typename: 'CompileDocIsolatedExpressionResultDiagnosticRecommendedIncludeIf', docId: string, itemId: string, itemPdfPath: string, itemTitle: string, expr: string, messageText: string, itemRecommendationId: string, itemRecommendationRank: number };

export type ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnosticFragment = ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticAskIf_Fragment | ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticAttribute_Fragment | ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticComputedProp_Fragment | ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticProductSearchFilterExpression_Fragment | ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticPropertyMapping_Fragment | ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticRecommendedEligibleIf_Fragment | ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic_CompileDocIsolatedExpressionResultDiagnosticRecommendedIncludeIf_Fragment;

export const ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnosticFragmentDoc = gql`
    fragment ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic on CompileDocIsolatedExpressionResultDiagnostic {
  ... on CompileDocIsolatedExpressionResultDiagnosticComputedProp {
    __typename
    docId
    itemId
    itemPdfPath
    itemTitle
    key
    expr
    messageText
  }
  ... on CompileDocIsolatedExpressionResultDiagnosticAttribute {
    __typename
    docId
    itemId
    itemPdfPath
    itemTitle
    attribute
    expr
    messageText
  }
  ... on CompileDocIsolatedExpressionResultDiagnosticPropertyMapping {
    __typename
    docId
    itemId
    itemPdfPath
    itemTitle
    toKey
    fromExpr
    messageText
  }
  ... on CompileDocIsolatedExpressionResultDiagnosticRecommendedEligibleIf {
    __typename
    docId
    itemId
    itemPdfPath
    itemTitle
    expr
    messageText
    itemRecommendationId
    itemRecommendationRank
  }
  ... on CompileDocIsolatedExpressionResultDiagnosticRecommendedIncludeIf {
    __typename
    docId
    itemId
    itemPdfPath
    itemTitle
    expr
    messageText
    itemRecommendationId
    itemRecommendationRank
  }
  ... on CompileDocIsolatedExpressionResultDiagnosticProductSearchFilterExpression {
    __typename
    docId
    itemId
    itemPdfPath
    itemTitle
    expr
    messageText
    filterKind
    filterKey
    propertyKey
    operator
    allowedOperators
  }
  ... on CompileDocIsolatedExpressionResultDiagnosticAskIf {
    __typename
    docId
    itemId
    itemPdfPath
    itemTitle
    key
    askIfExpr
    messageText
  }
}
    `;
export const ProjectQuoteTroubleshootDocument = gql`
    query ProjectQuoteTroubleshoot($projectId: ID!, $docId: ID!) {
  project(id: $projectId) {
    ... on ProjectResult {
      project {
        id
        ...QuoteSubHeader_Project
      }
    }
  }
  quote(projectId: $projectId, docId: $docId) {
    ... on QuoteResult {
      quote {
        id
        title
        rootItem {
          id
          originVersionNumber
        }
        ...QuoteSubHeader_Quote
      }
    }
  }
  compileDocIsolatedExpression(input: {docId: $docId, deep: true}) {
    ... on CompileDocIsolatedExpressionResult {
      results {
        ...ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnostic
      }
    }
  }
}
    ${QuoteSubHeader_ProjectFragmentDoc}
${QuoteSubHeader_QuoteFragmentDoc}
${ProjectQuoteTroubleshoot_CompileDocIsolatedExpressionResultDiagnosticFragmentDoc}`;

/**
 * __useProjectQuoteTroubleshootQuery__
 *
 * To run a query within a React component, call `useProjectQuoteTroubleshootQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuoteTroubleshootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuoteTroubleshootQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useProjectQuoteTroubleshootQuery(baseOptions: Apollo.QueryHookOptions<ProjectQuoteTroubleshootQuery, ProjectQuoteTroubleshootQueryVariables> & ({ variables: ProjectQuoteTroubleshootQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectQuoteTroubleshootQuery, ProjectQuoteTroubleshootQueryVariables>(ProjectQuoteTroubleshootDocument, options);
      }
export function useProjectQuoteTroubleshootLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuoteTroubleshootQuery, ProjectQuoteTroubleshootQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectQuoteTroubleshootQuery, ProjectQuoteTroubleshootQueryVariables>(ProjectQuoteTroubleshootDocument, options);
        }
export function useProjectQuoteTroubleshootSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectQuoteTroubleshootQuery, ProjectQuoteTroubleshootQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectQuoteTroubleshootQuery, ProjectQuoteTroubleshootQueryVariables>(ProjectQuoteTroubleshootDocument, options);
        }
export type ProjectQuoteTroubleshootQueryHookResult = ReturnType<typeof useProjectQuoteTroubleshootQuery>;
export type ProjectQuoteTroubleshootLazyQueryHookResult = ReturnType<typeof useProjectQuoteTroubleshootLazyQuery>;
export type ProjectQuoteTroubleshootSuspenseQueryHookResult = ReturnType<typeof useProjectQuoteTroubleshootSuspenseQuery>;
export type ProjectQuoteTroubleshootQueryResult = Apollo.QueryResult<ProjectQuoteTroubleshootQuery, ProjectQuoteTroubleshootQueryVariables>;